export const VISUALS = {
  WORLD: '/assets/visuals/world.webp',
}
